import styled from 'styled-components';

export const InsuranceFieldsLabel = styled.label`
  &&& {
    color: #444444;
    font-weight: 600;
    font-size: 16px;
    margin-bottom: 16px;
    float: none;
    text-align: left;
    padding: 0;
  }
`;

export const InsuranceFieldsInputContainer = styled.li`
  &&& {
    padding: 0 24px;
    margin-bottom: 32px;

    &:first-child {
      margin-top: 16px;
    }

    input {
      line-height: 24px;
      height: 24px;

      &:focus {
        box-shadow: none;
      }
    }
  }
`;
